import { useMutation } from '@tanstack/react-query';
import { RecommendArticleDto } from '@src/api/articles.ts';
import { API } from '@src/api/index.ts';

export const useRecommendArticleMutation = () => {
  return useMutation({
    mutationFn: async (body: RecommendArticleDto) => await API.articles.recommend(body),
  });
};
